import React, { useEffect, useCallback } from 'react';
import { Box, makeStyles } from '@material-ui/core';
import { useSelector, useDispatch } from 'react-redux';
import { hooks } from '@lifesize/clients.sdk';
import JoinForm from 'components/Guest/PreJoin/JoinForm';
import MicAndVideoPreview from 'components/Guest/PreJoin/MicAndVideoPreview';
import { RootState } from 'store/reducers';
import { useAcquireWebcam } from 'hooks/useAcquireWebcam';
import useVideoDeviceChanged from 'hooks/useVideoDeviceChanged';
import { vbbManager } from 'utils/vbbManager';
import { vbbSettingsSelector } from 'selectors/media';
import LocalVideoComponent from 'components/Guest/LocalVideo';
import { Theme } from '@material-ui/core/styles';

const PreJoin = () => {
  const dispatch = useDispatch();
  const acquireWebcam = useAcquireWebcam();
  const videoDeviceChanged = useVideoDeviceChanged();
  const { localVideoMuted } = hooks.useMedia();
  const { selection: bgSelection, enabled: vbbEnabled } = useSelector(vbbSettingsSelector);
  const classes = desktopStyles();
  const mediaSettings = useSelector((state: RootState) => state?.app?.mediaSettings);

  const handleNewCameraVBB = useCallback(() => {
    vbbManager.handleCameraChange(dispatch, localVideoMuted, vbbEnabled, bgSelection, mediaSettings);
  }, [dispatch, localVideoMuted, vbbEnabled, bgSelection, mediaSettings]);

  useEffect(() => {
    acquireWebcam();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (videoDeviceChanged) {
      handleNewCameraVBB();
    }
  }, [videoDeviceChanged, handleNewCameraVBB]);

  return (
    <Box className={classes.container}>
      <Box className={classes.content}>
        <Box className={classes.detailWrapper}>
          <JoinForm enableReinitialize />
        </Box>
        <Box className={classes.settingsPreview} data-testid="previewDivision">
          <LocalVideoComponent guestFlow />
          <MicAndVideoPreview />
        </Box>
      </Box>
    </Box>
  );
};

const desktopStyles = makeStyles((theme: Theme) => ({
  container: {
    display: 'flex',
    flexDirection: 'column',
    height: '100vh',
    maxWidth: '100%',
    overflow: 'hidden',
    padding: 0
  },
  content: {
    display: 'flex',
    flexDirection: 'row',
    height: '100%',
    width: '100%',
    overflow: 'hidden',
    '@media (orientation: portrait)': {
      flexDirection: 'column-reverse'
    }
  },
  detailWrapper: {
    display: 'flex',
    flex: '1 0 auto',
    [theme.breakpoints.up('md')]: {
      flex: '0 0 auto'
    },
    flexDirection: 'column',
    overflow: 'auto',
    justifyContent: 'center',
    '@media (orientation: landscape)': {
      maxWidth: '50%'
    },
    '@media (orientation: portrait)': {
      width: '100%'
    }
  },
  settingsPreview: {
    backgroundColor: '#000000',
    display: 'flex',
    flex: '5',
    flexDirection: 'column',
    height: 'calc(100vh - 51px)', // subtract the height of the header from the vh
    justifyContent: 'center',
    position: 'relative',
    overflow: 'hidden',
    '@media (orientation: portrait)': {
      maxWidth: '100%'
    }
  }
}));

export default PreJoin;
